import React, { useState, useEffect } from "react";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Calendar, momentLocalizer } from "react-big-calendar";
import { Row, Space, Spinner, Card } from "@masterteam/mt-design-react";
import "react-big-calendar/lib/css/react-big-calendar.css";

import CalendarToolbar from "./CalendarToolbar";

import api from "../../../providers/api";
import { useIsAr } from "../../../Hooks";
import { addToast, formatDate } from "../../../helpers";

import { ReactComponent as CalenderIcon } from "../../../assets/images/blue-calender.svg";

import "./style.scss";

const CalendarPage = () => {
  const [isAr] = useIsAr();
  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [view, setView] = useState("month");
  const [data, setData] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedDateEvents, setSelectedDateEvents] = useState([]);

  const localizer = momentLocalizer(moment);

  const getData = async () => {
    try {
      setLoading(true);

      const res = await api.taskCenter.getCalenderData();

      setData(res?.Data || []);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const getCellStyle = (date) => {
    const hasEvent = data.some((event) =>
      moment(date).startOf("day").isSame(moment(event.StartDate).startOf("day"))
    );

    if (hasEvent)
      return {
        backgroundColor: "#FFB33125",
        borderInlineStart: "4px solid #FFB331",
      };
    else return { borderInlineStart: "4px solid #ddd" };
  };

  const handleDateClick = (dateInfo) => {
    setSelectedDate(dateInfo.start);

    const events = data.filter((event) =>
      moment(dateInfo.start)
        .startOf("day")
        .isSame(moment(event.StartDate).startOf("day"))
    );

    setSelectedDateEvents(events);
  };

  return loading ? (
    <Row justify="center" style={{ marginTop: "24px" }}>
      <Spinner size="large" />
    </Row>
  ) : (
    <div className="page-wrapper">
      <Row
        align="center"
        justify="between"
        className="task-center-container__title cursor"
      >
        <FormattedMessage id="task-center.calendar" />
        <CalenderIcon
          onClick={() => {
            history.push("/splus/task-center/calendar");
          }}
        />
      </Row>
      <div size="large" className="page-wrapper__content">
        <Card className="calendar-container">
          <Calendar
            selectable
            drilldownView={false}
            localizer={localizer}
            events={data}
            onView={() => {}}
            view={view || "month"}
            views={["month", "week", "day"]}
            startAccessor="Start"
            endAccessor="Start"
            rtl={isAr}
            date={selectedDate}
            onSelectSlot={handleDateClick}
            dayPropGetter={(date) => ({
              style: getCellStyle(date),
            })}
            components={{
              toolbar: (props) => (
                <CalendarToolbar
                  toolbar={props}
                  data={data}
                  view={view}
                  setView={setView}
                  selectedDate={selectedDate}
                  setSelectedDate={setSelectedDate}
                  setSelectedDateEvents={setSelectedDateEvents}
                />
              ),
            }}
          />
        </Card>

        <Card direction="vertical" className="upcoming-events">
          <Row className="upcoming-events__header" align="center">
            <FormattedMessage id="task-center.upcoming-events" />
          </Row>

          <Space
            direction="vertical"
            className="upcoming-events__content"
            size="large"
          >
            {selectedDate ? (
              <div className="selected-date"> {formatDate(selectedDate)}</div>
            ) : null}

            {selectedDateEvents?.length ? (
              <ul className="list-wrapper">
                {selectedDateEvents?.map((e) => (
                  <li key={e.ID}>{isAr ? e.ArabicName : e.EnglishName}</li>
                ))}
              </ul>
            ) : (
              <Row justify="center">
                <FormattedMessage id="no-data" />
              </Row>
            )}
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default CalendarPage;
